import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { getUser } from "../../services/selectors";

function UnregisterRoute({element}) {

  const user = useSelector(getUser);
  const location = useLocation();

  return (
    user.loggedIn === false ? element : <Navigate to="/" replace state={{ from: location }}/>
  );
}

export default UnregisterRoute;
